import { apiCall } from "../../services/api-service";

export const submitProductAPI = async (body) => {
  try {
    const response = await apiCall("POST", "products", body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const updateProductStatusApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `products/status_update/${id}`, body);
    return response;
  } catch (err) {
    console.error("Error updating customer status:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const updateProductAPI = async (id, body) => {
  try {
    const response = await apiCall("PUT", `products/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getProductEditApi = async (id) => {
  try {
    const response = await apiCall("GET", `products/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getProductListApi = async (params) => {
  try {
    const response = await apiCall("GET", "products", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteProductApi = async (id) => {
  try {
    const response = await apiCall("DELETE", `products/delete/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const addProductAttachmentApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `products/attachment/${id}`, body);
    return response;
  } catch (err) {
    console.error("Error adding attachment:", err);
  }
};
